import { useState } from "react";
import { Menu, X, Sun } from "lucide-react";

const links = [
  { href: "#about", label: "About" },
  { href: "#philosophy", label: "Approach" },
  { href: "#services", label: "Services" },
  { href: "#payment", label: "Payment" },
  { href: "#faq", label: "FAQ" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const handleClick = (e, href) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className="sticky top-0 z-40 bg-sunlit-ivory/85 backdrop-blur-md border-b border-stone-200/60"
      data-testid="site-navbar"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a
          href="#top"
          onClick={(e) => handleClick(e, "#top")}
          className="flex items-center gap-2 group"
          data-testid="brand-link"
        >
          <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-full bg-sunlit-gold/20 ring-1 ring-sunlit-gold/40">
            <Sun className="h-5 w-5 text-sunlit-gold" strokeWidth={2.2} />
          </span>
          <span className="font-serif-display text-xl tracking-tight text-sunlit-ink">
            Sunlit&nbsp;<span className="italic text-sunlit-gold">Happiness</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => handleClick(e, l.href)}
              className="text-sm font-medium text-sunlit-mute hover:text-sunlit-ink transition-colors"
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#book"
          onClick={(e) => handleClick(e, "#book")}
          className="hidden md:inline-flex items-center justify-center rounded-full bg-sunlit-gold hover:bg-sunlit-gold-hover text-sunlit-ink px-5 py-2.5 text-sm font-medium tracking-wide transition-all shadow-sm hover:shadow-md hover:-translate-y-0.5"
          data-testid="nav-book-button"
        >
          Book Clarity Call
        </a>

        <button
          className="md:hidden inline-flex items-center justify-center h-10 w-10 rounded-full hover:bg-sunlit-cream"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-sunlit-ivory border-t border-stone-200/60" data-testid="nav-mobile-menu">
          <div className="px-4 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={(e) => handleClick(e, l.href)}
                className="text-base font-medium text-sunlit-ink py-2"
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#book"
              onClick={(e) => handleClick(e, "#book")}
              className="mt-2 inline-flex items-center justify-center rounded-full bg-sunlit-gold text-sunlit-ink px-5 py-3 font-medium"
              data-testid="nav-mobile-book-button"
            >
              Book Clarity Call
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
